// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CreateTab__container___pPxlq {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    width: 100%;
    height: 100%;
}

.CreateTab__content___SRaRY {
    display: flex;
    flex-direction: column;
    gap: 4rem;
    align-items: center;
}

.CreateTab__block___SdZ1G {
    display: flex;
    flex-direction: column;
    gap: 2.4rem;
    align-items: center;
}

.CreateTab__icon___INVJT {
    --icon-size: 6.4rem;
}

.CreateTab__button___uo_xS {
    width: 28.7rem;

    /* stylelint-disable-next-line selector-class-pattern -- Класс Consta */
    & .Button-Label {
        text-align: start;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/WorkAreas/CreateTab/CreateTab.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;;IAEvB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;;IAEd,uEAAuE;IACvE;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    width: 100%;\n    height: 100%;\n}\n\n.content {\n    display: flex;\n    flex-direction: column;\n    gap: 4rem;\n    align-items: center;\n}\n\n.block {\n    display: flex;\n    flex-direction: column;\n    gap: 2.4rem;\n    align-items: center;\n}\n\n.icon {\n    --icon-size: 6.4rem;\n}\n\n.button {\n    width: 28.7rem;\n\n    /* stylelint-disable-next-line selector-class-pattern -- Класс Consta */\n    & :global(.Button-Label) {\n        text-align: start;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CreateTab__container___pPxlq`,
	"content": `CreateTab__content___SRaRY`,
	"block": `CreateTab__block___SdZ1G`,
	"icon": `CreateTab__icon___INVJT`,
	"button": `CreateTab__button___uo_xS`
};
export default ___CSS_LOADER_EXPORT___;
